import React, { ButtonHTMLAttributes } from "react";
import classNames from "classnames";

export type SecondaryButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

/**
 * Our secondary CTA button style.
 * 
 * The component is a simple wrapper around the `.secondary-button` CSS class.
 * 
 * @status stable
 */
export const SecondaryButton: React.FC<SecondaryButtonProps> = ({ className, children, ...args }) => {
  return (
    <button
      type="button"
      className={classNames("secondary-button", className)}
      {...args}
    >
      <span>{children}</span>
    </button>
  );
};
